module.exports = __webpack_public_path__ + "img/telegram.264bccf.svg";